import React from 'react'
import ReactDOM from 'react-dom/client'
import Router from './Router'
import './index.css'

// Error Boundary to catch and display React errors
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error('🔴 React Error Caught:', error);
    console.error('🔴 Component Stack:', errorInfo?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '40px', 
          fontFamily: 'system-ui, sans-serif',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <h1 style={{ color: '#dc2626' }}>⚠️ Something went wrong</h1>
          <p style={{ fontSize: '18px', color: '#374151' }}>
            The app encountered an error. This helps us fix the issue:
          </p>
          
          <div style={{ 
            background: '#fef2f2', 
            border: '1px solid #fecaca',
            borderRadius: '8px',
            padding: '16px',
            marginTop: '20px'
          }}>
            <h3 style={{ color: '#991b1b', marginTop: 0 }}>Error Message:</h3>
            <code style={{ 
              display: 'block',
              background: '#fff',
              padding: '12px',
              borderRadius: '4px',
              color: '#dc2626',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word'
            }}>
              {this.state.error?.toString()}
            </code>
          </div>

          {this.state.errorInfo && (
            <div style={{ 
              background: '#f3f4f6', 
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              padding: '16px',
              marginTop: '20px'
            }}>
              <h3 style={{ color: '#374151', marginTop: 0 }}>Component Stack:</h3>
              <pre style={{ 
                background: '#fff',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '12px',
                maxHeight: '300px'
              }}>
                {this.state.errorInfo.componentStack}
              </pre>
            </div>
          )}

          <div style={{ marginTop: '30px' }}>
            <button 
              onClick={() => {
                // Clear localStorage/sessionStorage and reload
                try {
                  localStorage.clear();
                  sessionStorage.clear();
                } catch(e) {}
                window.location.reload();
              }}
              style={{
                background: '#2563eb',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                fontSize: '16px',
                cursor: 'pointer',
                marginRight: '12px'
              }}
            >
              🗑️ Clear Cache & Reload
            </button>
            <button 
              onClick={() => window.location.reload()}
              style={{
                background: '#6b7280',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                fontSize: '16px',
                cursor: 'pointer'
              }}
            >
              🔄 Just Reload
            </button>
          </div>
          
          <p style={{ marginTop: '20px', color: '#6b7280', fontSize: '14px' }}>
            If this keeps happening, please share a screenshot with the developer.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router />
    </ErrorBoundary>
  </React.StrictMode>,
)
